export default __webpack_public_path__ + "static/media/layout_dark_pattern-sensing.0767e1e9.svg";